<script>
import { Bubble, mixins } from "vue-chartjs";
import EventHubListenerMixin from "../../common/mixins/EventHubListener";
import { createAnimationOptions } from "../../../utils/chartAnimations";
const { reactiveProp } = mixins;

export default {
  name: "ChartPivotTemplate",
  extends: Bubble,
  mixins: [reactiveProp],  // EventHubListenerMixin
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    animationType: {
      type: String,
      default: 'smooth'
    }
  },
  methods: {
    renderBubbleChart: function () {
      // Используем настройки анимации из утилиты для bubble графиков
      const animationOptions = createAnimationOptions(this.animationType, 'bubble');
      const animatedOptions = {
        ...this.options,
        ...animationOptions
      };

      this.renderChart(this.chartData, animatedOptions, {
        responsive: true,
        maintainAspectRatio: false,
      });
    },
  },
  watch: {
    data: function () {
      this.renderBubbleChart();
    },
  },
  mounted() {
    this.renderBubbleChart();
  },
};
</script>

<style></style>
